// extracted by mini-css-extract-plugin
export default {"settings_item":"SettingsItem_settings_item__gMeT0","focus":"SettingsItem_focus__Ijl9e","show_checkbox":"SettingsItem_show_checkbox__jE+lS","checked":"SettingsItem_checked__3gehc"};